export default "__VITE_ASSET__60c685e3__"